import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import type { CustomIcons } from "./Icons.type";

const size: CustomIcons = {
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.38809 1.67187C7.67059 1.22046 8.32813 1.22046 8.61063 1.67187L10.512 4.71008C10.6109 4.86821 10.7673 4.98184 10.9483 5.0271L14.4254 5.89653C14.942 6.02571 15.1452 6.65106 14.8031 7.05922L12.5012 9.80637C12.3814 9.94936 12.3216 10.1332 12.3345 10.3193L12.5821 13.8949C12.6189 14.4261 12.0869 14.8126 11.5931 14.6134L8.26903 13.2731C8.09602 13.2033 7.9027 13.2033 7.72969 13.2731L4.40565 14.6134C3.91177 14.8126 3.37982 14.4261 3.4166 13.8949L3.66419 10.3193C3.67708 10.1332 3.61734 9.94936 3.49753 9.80637L1.19557 7.05922C0.85355 6.65106 1.05674 6.02571 1.57335 5.89653L5.05041 5.0271C5.23138 4.98184 5.38778 4.86821 5.48675 4.71007L7.38809 1.67187Z"
        fill="currentColor"
      />
    </svg>
  ),
  medium: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0821 2.50784C11.5059 1.83072 12.4922 1.83072 12.9159 2.50784L15.768 7.06514C15.9164 7.30235 16.151 7.47279 16.4225 7.54068L21.638 8.84482C22.413 9.03859 22.7178 9.97662 22.2047 10.5889L18.7518 14.7096C18.5721 14.9241 18.4825 15.1999 18.5018 15.479L18.8732 20.8423C18.9284 21.6392 18.1304 22.2189 17.3896 21.9202L12.4036 19.9096C12.144 19.805 11.8541 19.805 11.5945 19.9096L6.60848 21.9202C5.86766 22.2189 5.06973 21.6392 5.12491 20.8423L5.49629 15.479C5.51562 15.1999 5.42601 14.9241 5.24629 14.7096L1.79336 10.5889C1.28032 9.97662 1.58511 9.03859 2.36003 8.84482L7.57561 7.54068C7.84708 7.47279 8.08167 7.30235 8.23012 7.06514L11.0821 2.50784Z"
        fill="currentColor"
      />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.7762 3.3438C15.3412 2.44098 16.6563 2.44098 17.2213 3.34381L21.0239 9.42021C21.2219 9.73649 21.5347 9.96375 21.8966 10.0543L28.8507 11.7931C29.884 12.0515 30.2903 13.3022 29.6063 14.1185L25.0024 19.6128C24.7628 19.8988 24.6433 20.2665 24.6691 20.6387L25.1642 27.7898C25.2378 28.8523 24.1739 29.6253 23.1861 29.227L16.5381 26.5462C16.192 26.4067 15.8054 26.4067 15.4594 26.5462L8.8113 29.227C7.82354 29.6253 6.75964 28.8523 6.83321 27.7898L7.32839 20.6387C7.35416 20.2665 7.23468 19.8988 6.99505 19.6128L2.39114 14.1185C1.7071 13.3022 2.11348 12.0515 3.14671 11.7931L10.1008 10.0543C10.4628 9.96375 10.7756 9.73649 10.9735 9.42021L14.7762 3.3438Z"
        fill="currentColor"
      />
    </svg>
  ),
};

function StarIcon(props: SvgIconProps) {
  const item = props.fontSize === "large" || props.fontSize === "small" ? size[props.fontSize] : size.medium;
  return <SvgIcon {...props}>{item}</SvgIcon>;
}
export default StarIcon;
